const React = require('react');
const HtmlToReact = require('html-to-react');
const HtmlToReactParser = require('html-to-react').Parser;

export default function HistoricData({ historic_formated_text }) {
  const htmlToReactParser = new HtmlToReactParser();
  const processNodeDefinitions = new HtmlToReact.ProcessNodeDefinitions(React);
  const isValidNode = function () {
    return true;
  };

  // Order matters. Instructions are processed in
  // the order they're defined
  const processingInstructions = [
    {
      // remove all code from within a script.
      replaceChildren: true,
      shouldProcessNode: function (node) {
        return node.name && node.name=== 'script';
      },
      processNode: function (node, children, index) {
        return '';
      }
    },
    {
      // Anything else
      shouldProcessNode: function (node) {
        return true;
      },
      processNode: processNodeDefinitions.processDefaultNode,
    },
  ];

  return htmlToReactParser.parseWithInstructions(
    '<div>' + historic_formated_text + '</div>', isValidNode, processingInstructions);
}
